import memoize from '../memoize';

const notificationsHelperFactory = ({ model, path }) => {
    const _handlerMap = {};

    const remove = (id) => {
        model.del(`${path}.${id}`);
        delete _handlerMap[id];
    };

    const buildNotificationsArray = memoize((notifications = {}) => {
        const ids = Object.keys(notifications);
        const result = ids.map((id) => {
            const { msg, type } = notifications[id];
            const onClose = _handlerMap[id];

            return {
                id,
                msg,
                type,
                close: () => {
                    const result = onClose ? onClose() : true;

                    if (result) {
                        remove(id);
                    }
                },
            };
        });

        return result;
    });

    const get = () => {
        const notifications = model.get(`${path}`);

        return buildNotificationsArray(notifications);
    };

    const set = (notification) => {
        const { id, msg, type, onClose } = notification;

        model.set(`${path}.${id}`, { msg, type }, false);
        _handlerMap[id] = onClose;
    };

    return {
        get,
        set,
        remove,
    };
};

export default notificationsHelperFactory;
